module.exports = __webpack_public_path__ + "static/aloopproxfront-0447cfdb4e357a75e521cef03e1469ca.png";